<template>
	<div class="container">
		<div class="header bar">
			<!-- <router-link to="/visit"> -->
			<span class="btn-back" @click="closeWindow">
				차고지 신청
			</span>
			<!-- </router-link> -->
		</div>
		<div class="contents">
			<div class="info-box">
				<!-- 법인화물 설명 -->
				<p class="info-title" v-show="cargoCorporation">
					차고지 신청을 위해 필요 정보를 입력해주세요.<br />
					확인 후 차고지 전담팀에서 전화드리겠습니다.
				</p>
				<!-- 개인화물 설명 -->
				<p class="info-title" v-show="cargoPersonal">
					<strong class="color-orange">‘차고지 증명제’</strong>란 주차공간을 확보해야 차를 구입할 수 있게 하는 제도로 화물차, 버스, 렌트 차량의 신규·
					변경·이전 등록 때 차고지 확보 증빙서류를 관할 시· 군·구청에 <strong>의무적으로 제출해야 하는 제도</strong>입니다.<br />번거로운
					<strong>차고지 신청을 대행</strong>해 드리니, <strong>차고지 신청이 필요하신 분은 필요 정보를 입력</strong>하세요.<br />확인 후 차고지
					전담팀에서 전화드리겠습니다.
				</p>
			</div>
			<div class="inp-box">
				<div class="line">
					<p class="part-title">화물 종류 선택</p>
					<div class="btn-list clearfix">
						<div class="item f-left">
							<button :class="cargoCorporation ? 'on' : ''" @click.prevent="changeCargo('CORPORATION')">법인화물</button>
						</div>
						<div class="item f-left">
							<button :class="cargoPersonal ? 'on' : ''" @click.prevent="changeCargo('PERSSONAL')">개인화물</button>
						</div>
					</div>
				</div>
				<div class="line">
					<p class="part-title">이름</p>
					<p>
						<input type="text" v-model="name" ref="nameField" />
					</p>
					<p class="error-title" v-show="!validName">이름을 정확하게 입력해주세요.</p>
				</div>
				<div class="line">
					<p class="part-title">휴대전화</p>
					<p>
						<input type="tel" v-model="mobile" ref="mobileField" />
					</p>
					<p class="error-title" v-show="!validMobile">휴대전화 번호를 정확하게 입력해주세요.</p>
				</div>
				<div class="line">
					<p class="part-title">서류 등록</p>
					<p class="info-title sub">
						<span class="color-gray">원활하고 신속한 차고지 신청을 위해</span><br />
						<span :class="validAttach ? 'color-gray' : 'color-orange'">
							차량등록증
							<span v-show="cargoCorporation">
								과 사업자등록증
							</span>
							을 반드시 등록해주세요.
						</span>
					</p>
					<div class="upload-list">
						<div class="item upload-area">
							<!-- 법인화물 -->
							<label for="file_upload" v-if="cargoCorporation">차량등록증/사업자등록증 등록</label>
							<!-- 개인화물 -->
							<label for="file_upload" v-if="cargoPersonal">차량등록증 등록</label>
							<input type="file" id="file_upload" @change="fileChange" accept="image/*" />
						</div>
						<p v-for="(item, index) in fileList" :key="index" class="item">
							{{ item.name }}
							<button class="btn-file-delete" @click="removeFile(index)">삭제</button>
						</p>
					</div>
				</div>
				<div class="line">
					<p class="part-title">차고지 설치 희망 주소</p>
					<p class="info-title sub color-gray">희망 주소에 차고지가 없을 경우 가능한 차고지로 안내합니다.</p>
					<div class="select-list clearfix">
						<div class="item f-left">
							<select name="states" v-model="states">
								<option v-for="item in cityList" :key="item.id" :value="item.id">{{ item.name }}</option>
							</select>
						</div>
						<div class="item f-left">
							<select name="city" v-model="city">
								<option v-for="item in countyList" :key="item.id" :value="item.id">{{ item.name }}</option>
							</select>
						</div>
					</div>
				</div>
			</div>
			<div class="chk-box">
				<p class="line">
					<label for="privacy">
						<input type="checkbox" v-model="privacy" class="hidden square" id="privacy" />
						<span> [<button class="btn-link" @click="moveTerms('privacy')">개인정보 수집, 이용(필수)</button>] 내용에 동의합니다. </span>
					</label>
				</p>
				<p class="line">
					<label for="third">
						<input type="checkbox" v-model="third" class="hidden square" id="third" />
						<span> [<button class="btn-link" @click="moveTerms('third')">개인정보의 제3자 제공 동의</button>] 내용에 동의합니다. </span>
					</label>
				</p>
			</div>
			<div class="btn-box">
				<button class="btn big yellow radius" @click.prevent="checkModel">
					정보 입력 완료
				</button>
			</div>
		</div>
		<div class="dimmed" :class="{ active: isDimmed }">
			<!-- <img src="images/loaing.svg" /> -->
		</div>
	</div>
</template>

<script>
import axios from 'axios';

export default {
	name: 'Apply',
	components: {},
	filters: {},
	mixins: [],
	extends: {},
	props: {},
	data() {
		return {
			country: {},
			cityList: [],
			countyList: [],
			fileList: [],

			nameRegex: /^[가-힣|a-z|A-Z|\s]{2,20}$/,
			mobileRegex: /^(01[0-9])-?([0-9]{3,4})-?([0-9]{4})$/,
			openPrivacy: false, // popup open용
			openThird: false, // popup open용

			states: '11', // 시도군
			city: '11110', // 동

			selectCargo: 'CORPORATION',
			name: '',
			mobile: '',
			privacy: false,
			third: false,

			isDimmed: false
		};
	},
	computed: {
		fileLength() {
			return this.fileList.length;
		},
		validName() {
			return this.nameRegex.test(this.name);
		},
		validMobile() {
			return this.mobileRegex.test(this.mobile);
		},
		validAttach() {
			return this.cargoCorporationFileAttached && this.cargoPersonalFileAttached;
		},
		validResult() {
			return this.validName && this.validMobile;
		},
		cargoCorporation() {
			return this.selectCargo === 'CORPORATION';
		},
		cargoPersonal() {
			return this.selectCargo === 'PERSSONAL';
		},
		cargoCorporationFileAttached() {
			return !this.cargoCorporation || this.fileLength === 2;
		},
		cargoPersonalFileAttached() {
			return !this.cargoPersonal || this.fileLength === 1;
		}
	},
	watch: {
		states: function() {
			this.getCity();
		}
	},
	methods: {
		getCountry() {
			axios
				.get('https://apis.iparking.co.kr/garage/api/common/address/country')
				.then(resp => {
					this.countryList = resp.data.resultData.countries.find(v => v.id === 'KOR');
					this.getCity();
				})
				.catch(error => console.trace(error.message));
		},
		getCity() {
			axios
				.get('https://apis.iparking.co.kr/garage/api/common/address/state', { params: { countryId: this.countryList.id } })
				.then(resp => {
					this.cityList = resp.data.resultData.states;
					this.getCounty();
				})
				.catch(error => console.trace(error.message));
		},
		getCounty() {
			axios
				.get('https://apis.iparking.co.kr/garage/api/common/address/city', { params: { stateId: this.states } })
				.then(resp => {
					this.countyList = resp.data.resultData.cities;
					this.city = this.countyList[0].id;
				})
				.catch(error => console.trace(error.message));
		},
		isProvisionChecked() {
			if (!this.privacy) {
				alert('"개인정보 수집,이용"항목에 동의해야 합니다.');
				return;
			}
			if (!this.third) {
				alert('"개인정보의 제3자 제공 동의"항목에 동의해야 합니다.');
				return;
			}

			return true;
		},
		isValidFileLength() {
			// todo : 문구 요청
			if (!this.cargoCorporationFileAttached) {
				alert('차량등록증 및 사업자등록증을 등록해주세요.');
				return;
			}

			if (!this.cargoPersonalFileAttached) {
				alert('차량등록증을 등록해주세요.');
				return;
			}

			return true;
		},
		isValidPersonalInfo() {
			// todo : 문구 요청
			if (!this.validName) {
				alert('이름이 올바른지 확인해주세요.');
				this.scrollTo(this.$refs.nameField);
				this.$refs.nameField.focus();
				return;
			}

			if (!this.validMobile) {
				alert('전화번호 형식이 올바른지 확인해주세요.');
				this.scrollTo(this.$refs.mobileField);
				this.$refs.mobileField.focus();
				return;
			}

			return true;
		},
		checkModel() {
			this.isValidPersonalInfo() && this.isValidFileLength() && this.isProvisionChecked() && this.applyGarage();
		},
		applyGarage() {
			this.isDimmed = true;
			let formData = new FormData();

			formData.append('businessClassification', this.selectCargo);
			formData.append('stateId', this.states);
			formData.append('cityId', this.city);
			formData.append('countryId', this.countryList.id);
			formData.append('mobileNumber', this.mobile.trim().replace(/-/g, ''));
			formData.append('name', this.name.trim());
			formData.append('vehicleImageFiles', this.fileList[0].file);

			this.cargoCorporation && formData.append('businessImageFiles', this.fileList[1].file);

			axios
				.post('https://apis.iparking.co.kr/garage/api/alliance/hyundaicommerce/apply', formData, {
					headers: { 'Content-Type': 'multipart/form-data' }
				})
				.then(resp => {
					this.isDimmed = false;
					if (resp.status === 200) {
						this.$router.replace({ name: 'complete' });
					}
				})
				.catch(error => {
					console.trace(error.message);
					this.isDimmed = false;
				});
		},
		fileChange(e) {
			if (!e || this.changeFileLength()) return;

			const file = e.target.files[0];

			this.fileList.push({
				file: file,
				name: file.name
			});
		},
		changeFileLength() {
			const fileLength = this.fileList.length;
			let flag = false;

			if (this.cargoCorporation) {
				fileLength === 2 && (alert('차량등록증/사업자등록증 사진을 첨부하여야 합니다.'), (flag = true)); // todo : 문구 요청
			}

			if (this.cargoPersonal) {
				fileLength === 1 && (alert('차량등록증 사진을 첨부하여야 합니다.'), (flag = true)); // todo : 문구 요청
			}

			return flag;
		},
		changeCargo(v) {
			this.selectCargo = v;
			this.fileList = [];
		},
		removeFile(index) {
			this.fileList.splice(index, 1);
		},
		moveTerms(type) {
			this.$store.commit('setData', this);
			this.$router.push({ name: 'terms', params: { type: type } });
		},
		rememberInfo() {
			const state = this.$store.state;
			Object.keys(state).forEach(v => state[v] && (this[v] = state[v]));
			state.city && setTimeout(() => (this.city = state.city), 333);
		},

		scrollTo(element) {
			const top = element.offsetTop;
			window.scrollTo({
				top: top,
				left: 0,
				behavior: 'smooth'
			});
		},

		closeWindow() {
			window.close();
		}
	},

	beforeCreate() {},
	created() {
		this.rememberInfo();
		this.getCountry();
	},
	beforeMount() {},
	mounted() {},
	beforeUpdate() {},
	updated() {},
	beforeDestroy() {},
	destroyed() {}
};
</script>

<style lang="scss" scoped>
.btn-list {
	.item {
		width: 50%;

		&:nth-child(odd) {
			padding-right: 0.35em;
		}

		&:nth-child(even) {
			padding-left: 0.35em;
		}
	}

	button {
		width: 100%;
		height: 50px;
		line-height: 50px;
		border: 1px solid #e0e0dd;
		border-radius: 8px;
		font-size: 1.02em;
		color: #e8e8e8;

		&.on {
			border: 1px solid #ff6200;
			font-weight: 500;
			color: #ff6200;
		}
	}
}

.select-list {
	.item {
		width: 50%;

		&:nth-child(odd) {
			padding-right: 0.35em;
		}

		&:nth-child(even) {
			padding-left: 0.35em;
		}
	}

	select {
		width: 100%;
	}
}

.upload-list {
	.item {
		margin-bottom: 0.7em;
		font-size: 0.9em;
		color: #595957;

		&:last-child {
			margin-bottom: 0;
		}
	}

	.btn-file-delete {
		display: inline-block;
		width: 20px;
		height: 16px;
		background: url(../assets/images/ico_close_mini.svg) no-repeat 0 50%;
		text-indent: -99999px;
		font-size: 0;
		vertical-align: middle;
	}
}

.upload-area {
	position: relative;

	label {
		display: inline-block;
		width: 100%;
		height: 50px;
		line-height: 50px;
		border-radius: 8px;
		background-color: #f0efea;
		text-align: center;
		font-size: 1.14em;
		font-weight: 500;
		color: #000;
	}

	input {
		&[type='file'] {
			position: absolute;
			width: 1px;
			height: 1px;
			padding: 0;
			margin: -1px;
			overflow: hidden;
			clip: rect(0, 0, 0, 0);
			border: 0;
		}
	}
}

.dimmed {
	position: fixed;
	top: 0px;
	left: 0px;
	width: 100%;
	height: 100%;
	background-color: rgba(0, 0, 0, 0.4);
	background-image: url(../assets/images/loading.svg);
	background-repeat: no-repeat;
	background-position: center center;
	background-size: 128px 128px;
	display: none;

	&.active {
		display: block;
	}
}
</style>
